import axios from "axios";
import { API_URL } from "../../const";

/*************** COMPANY DETAILS ADD START *************** */
export const companyDetailsAdd = (addData: any) => {
  const data = {
    CreateCompanyToken: addData,
  };
  const url = `${API_URL}CreateCompany`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** COMPANY DETAILS ADD END *************** */

/*************** COMPANY DETAILS UPDATE START *************** */
export const companyDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateCompanyToken: updateData,
  };
  const url = `${API_URL}UpdateCompany`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/************* COMPANY DETAILS UPDATE END *************** */

/*************** COMPANY DETAILS GET START *************** */
export const companyListGet = (listData: any) => {
  const data = {
    GetAllCompanyPaginationToken: listData,
  };
  const url = `${API_URL}GetAllCompanyDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** COMPANY DETAILS GET END *************** */

/*************** COMPANY DETAILS FETCH START *************** */
export const companyDetailsFetch = (fetchData: any) => {
  const data = {
    GetCompanyToken: fetchData,
  };
  const url = `${API_URL}FetchCompanyDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** COMPANY DETAILS FETCH END *************** */

/*************** COMPANY DETAILS DELETE START *************** */
export const companyDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteCompanyToken: deleteData,
  };
  const url = `${API_URL}DeleteCompany`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** COMPANY DETAILS DELETE END *************** */

/*************** Create Instance Company For Start ******************/
export const instanceDetailsAdd = (listData: any) => {
  const data = {
    CreateInstanceDBToken: listData,
  };
  const url = `${API_URL}instanceCreateCompany`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};
/***************  Create Instance Company For End ******************/
